export const STATION_BUSY_BORROW_CODE = 50107;

function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export function isStationBusyBorrowError(error) {
    return Number(error && error.code) === STATION_BUSY_BORROW_CODE;
}

export async function borrowWithStationBusyRetry(requestBorrow, options = {}) {
    const retryDelayMs = options.retryDelayMs ?? 1000;
    const maxWaitMs = options.maxWaitMs ?? 60000;
    const onStationBusyChange = options.onStationBusyChange;
    const startedAt = Date.now();
    let isStationBusy = false;

    try {
        while (true) {
            try {
                return await requestBorrow();
            } catch (error) {
                if (!isStationBusyBorrowError(error)) {
                    throw error;
                }

                if (!isStationBusy) {
                    isStationBusy = true;
                    if (typeof onStationBusyChange === "function") {
                        onStationBusyChange(true);
                    }
                }

                if (Date.now() - startedAt >= maxWaitMs) {
                    throw error;
                }

                await sleep(retryDelayMs);
            }
        }
    } finally {
        if (isStationBusy && typeof onStationBusyChange === "function") {
            onStationBusyChange(false);
        }
    }
}
